module.exports = __webpack_public_path__ + "static/media/ageing.b20a4246.png";